import React, {useState} from 'react';
 import MachineSubcard from '../MachineSubcard';

function Index(props) {

    let firstTitle = props.firstTitle;
    let secondTitle = props.secondTitle;

    let CastIronBroaching = [
        {
            "title":"Variocut B 46 TC",
            "text":"A chlorine and heavy metal free neat cutting oil specially formulated with a special combination of ester, extreme pressure (EP) and anti-wear additives to help to optimise machining performance and enhance tool life. It is designed for severe broaching and gear cutting of high alloy steel and stainless steel. Variocut B 46 TC contains active sulphur and is not compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-b-46-tc/industrial/en-JP"
        },
        {
            "title":"Variocut C 462",
            "text":"A chlorine free neat cutting oil developed using highly refined base oils and ester additives which can help to provide excellent machininig performance and enhanced surface finish. It is recommended for general machining of non-ferrous material specially copper and aluminum alloys. Variocut C 462 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-c-462/industrial/en-JP"
        },
        {
            "title":"Hysol SL 35 XBB",
            "text":"Semi-synthetic, chlorine, formaldehyde releasing agent and boron free metalworking fluid for grinding of steel, machining of low-medium alloyed steel and cast iron with excellent anti corrosion and long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-sl-35-xbb/industrial/en-JP"
        },
        {
            "title":"Syntilo 9974 BF",
            "text":"Boron and formaldeyhde releasing agent free, oil rejecting synthetic coolant which has been developed for heavy duty machining and grinding of ferrous alloys.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-9974-bf/industrial/en-JP"
        },
        {
            "title":"Alusol RAL BF J",
            "text":"Semi-synthetc, chlorine, boron and formaldehyde releasing agent free metalworking fluid for demanding machining of aluminium alloys and low-medium alloyed steel with good system life.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-ral-bf-j/industrial/en-JP"
        },
        {
            "title":" CareCut S 600",
            "text":"Soluble, chlorine free metalworking fluid based on selected ester technology for machining of aluminium alloys and steel with long system life and excellent anti foam properties in soft water.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-s-600/industrial/en-JP"
        },
    ];

    let CastIronDeepDrilling = [
        {
            "title":"Hysol SL 45 XBB",
            "text":"Castrol HysolTM SL 45 XBB is a high performance soluble metalworking fluid which is boron, formaldehyde releasing agent and chlorine free.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-sl-45-xbb/industrial/en-JP"
        },
        {
            "title":"Alusol MF",
            "text":"Semi-synthetic, chlorine free metalworking fluid for machining of aluminium alloys and low-medium alloyed steel with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-mf/industrial/en-JP"
        },
        {
            "title":"CareCut ES 2",
            "text":"It is designed for high speed, creep feed and gear grinding of ferrous and non-ferrous metals including titanium & other super alloys. It can also be used for drilling and general machining applications, as well as for hard metal and tool grinding. CareCut ES 2 does not contain active sulphur and is hence compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-2/industrial/en-JP"
        },
        {
            "title":"Variocut C 462",
            "text":"A chlorine free neat cutting oil developed using highly refined base oils and ester additives which can help to provide excellent machininig performance and enhanced surface finish. It is recommended for general machining of non-ferrous material specially copper and aluminum alloys. Variocut C 462 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-c-462/industrial/en-JP"
        },
        {
            "title":"Syntilo 27",
            "text":"Oil-dispersing synthetic coolant which has been developed for general purpose grinding and light to medium duty machining of ferrous alloys. Syntilo 27 exhibits good anti-corrosion properties coupled with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-27/industrial/en-JP"
        },
        {
            "title":"Syntilo 9902",
            "text":"Formaldehye releasing agent free, oil rejecting synthetic coolant which has been developed for general purpose grinding and light duty machining of ferrous alloys. It forms a clear, stable solution in both hard and soft waters. Syntilo 9902 exhibits good anti-corrosion properties coupled with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-9902/industrial/en-JP"
        },
    ];

    let CastIronGrinding = [
        {
            "title":"Syntilo 9930",
            "text":"Formaldeyhde releasing agent free, oil rejecting synthetic coolant which has been developed for general purpose grinding and light to medium duty machining of ferrous alloys. It forms a clear, stable solution in both hard and soft waters. Syntilo 9930 exhibits good anti-corrosion properties coupled with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-9930/industrial/en-JP"
        },
        {
            "title":"Hysol SL 35 XBB",
            "text":"Semi-synthetic, chlorine, formaldehyde releasing agent and boron free metalworking fluid for grinding of steel, machining of low-medium alloyed steel and cast iron with excellent anti corrosion and long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-sl-35-xbb/industrial/en-JP"
        },
        {
            "title":"Variocut B 46 TC",
            "text":"A chlorine and heavy metal free neat cutting oil specially formulated with a special combination of ester, extreme pressure (EP) and anti-wear additives to help to optimise machining performance and enhance tool life. It is designed for severe broaching and gear cutting of high alloy steel and stainless steel. Variocut B 46 TC contains active sulphur and is not compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-b-46-tc/industrial/en-JP"
        },
        {
            "title":"Alusol RAL BF J",
            "text":"Semi-synthetc, chlorine, boron and formaldehyde releasing agent free metalworking fluid for demanding machining of aluminium alloys and low-medium alloyed steel with good system life.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-ral-bf-j/industrial/en-JP"
        },
        {
            "title":"CareCut S 600",
            "text":"Soluble, chlorine free metalworking fluid based on selected ester technology for machining of aluminium alloys and steel with long system life and excellent anti foam properties in soft water.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-s-600/industrial/en-JP"
        },
        {
            "title":"Syntilo 81 E",
            "text":"Formaldehye releasing agent free, oil rejecting synthetic coolant developed for use as a general purpose grinding of ferrous alloys. It is extreme low foaming in recommended water conditions and forms a clear, stable solution in both soft and hard water. Syntilo 81 E shows excellent anti corrosion properties and long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-81-e/industrial/en-JP"
        },
    ];

    let CastIronMilling = [
        {
            "title":"Almaredge BI",
            "text":"Castrol Almaredge™ BI is a general purpose soluble metalworking fluid which is chlorine and boron-free.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-bi/industrial/en-JP"
        },
        {
            "title":"Syntilo 1023 BF",
            "text":"Boron and formaldehyde releasing agent free, oil-dispersing synthetic cutting and grinding fluid formulated for use in cast iron transfer lines. Syntilo 1023 is engineered to separate tramp oil to the surface of the fluid where it can be removed by skimming. It also disperses small amounts of oil throughout the fluid to create a thin film which protects parts, chips and machine surfaces. This oil-dispersing characteristic reduces corrosion and prevents clinkering.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-1023-bf/industrial/en-JP"
        },
        {
            "title":"Hysol 701 EF",
            "text":"Castrol Hysol™ 701 EF (previously called Clearedge™ 701 EF)is a high performance semi-synthetic metalworking fluid which is boron, formaldeyhde releasing agent and chlorine free. It contains an additive package that works in synergy to enhance machining performance and surface finish, provide excellent product stability, improve bio-resistance properties and lower the overall operations costs.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-701-ef/industrial/en-JP"
        },
        {
            "title":"Alusol B",
            "text":"Soluble, chlorine free metalworking fluid for machining of aluminium alloys and low-medium alloyed steel with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-b/industrial/en-JP"
        },
        {
            "title":"CareCut ES 1",
            "text":"A chlorine and heavy metal-free neat cutting oil, based on advanced ester technology",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-1/industrial/en-JP"
        },
        {
            "title":"Variocut B 30",
            "text":"A chlorine free neat cutting oil specially formulated with a special combination of ester, extreme pressure (EP) and anti-wear additives to help to optimise machining performance and enhance tool life.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-b-30/industrial/en-JP"
        },
    ];

    let CastIronDrilling = [
        {
            "title":"CareCut ES 4",
            "text":"A chlorine and heavy metal-free neat cutting oil, based on advanced ester technology. It is used for general machining of ferrous and non-ferrous metals where very high surface finish is required. CareCut ES 4 does not contain active sulphur and is hence compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-4/industrial/en-JP"
        },
        {
            "title":"Alusol B",
            "text":"Soluble, chlorine free metalworking fluid for machining of aluminium alloys and low-medium alloyed steel with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-b/industrial/en-JP"
        },
        {
            "title":"Hysol 6754",
            "text":"Castrol Hysol™ 6754 (previously named Superedge™ 6754) is a high performance soluble metalworking fluid which is formaldehyde releasing agent, boron and chlorine free. It contains an additive package that works in synergy to enhance machining performance and surface finish, provide excellent product stability, improve bio-resistance properties and lower the overall operations costs.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-6754/industrial/en-JP"
        },
        {
            "title":"Syntilo 1023 BF",
            "text":"Boron and formaldehyde releasing agent free, oil-dispersing synthetic cutting and grinding fluid formulated for use in cast iron transfer lines. Syntilo 1023 is engineered to separate tramp oil to the surface of the fluid where it can be removed by skimming.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-1023-bf/industrial/en-JP"
        },
        {
            "title":"Almaredge 230",
            "text":"Soluble chlorine free metalworking fluid for general machining of ferrous metals, with excellent system life and foaming properties in soft water.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-230/industrial/en-JP"
        },
        
    ];

    let CastIronSuperfinishing = [
        {
            "title":"Honilo 930",
            "text":"A chlorine and heavy metal free, low viscosity neat cutting oil specially designed for honing and superfinishing of ferrous and non-ferrous materials. Honilo 430 does not contain active sulphur and is compatible with yellow metals",
            "link":"https://thelubricantoracle.castrol.com/product/honilo-930/industrial/en-JP"
        },
        {
            "title":"Honilo 981",
            "text":"A chlorine and heavy metal free low viscosity neat cutting oil for honing and superfinishing of cast iron, steel and aluminium alloys, where critical dimensional accuracy are required.",
            "link":"https://thelubricantoracle.castrol.com/product/honilo-981/industrial/en-JP"
        },
        {
            "title":"Honilo 988",
            "text":"A chlorine and heavy metal free low viscosity neat cutting oil specially designed for honing and superfinishing of ferrous and non-ferrous materials. It is specially designed to inhibit staining where sulphurised honing sticks are used and to improve in-process corrosion protection for the bearing industry. Honilo 988 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/honilo-988/industrial/en-JP"
        },
        
    ];

    let HighAlloySteelBroaching = [
        {
            "title":"Variocut C 210",
            "text":"A chlorine and heavy metal-free neat cutting oil specially designed with hydrocracked (HC) base oil technology and advanced esters which can help to optimise machining performance on a wide range of light duty general machining applications on ferrous as well as non-ferrous alloys.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-c-210/industrial/en-JP"
        },
        {
            "title":"CareCut ES 1",
            "text":"It is used for general machining of ferrous and non-ferrous metals where very high surface finish is required. CareCut ES 1 does not contain active sulphur and is hence compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-1/industrial/en-JP"
        },
        {
            "title":"Alusol SL 61 XBB",
            "text":"Castrol Alusol™ SL 61 XBB (previously called Alusol RBF) is a high performance semi-synthetic metalworking fluid which is boron, formaldehyde releasing agent and chlorine-free. It contains an additive package that may help to enhance machining performance and surface finish. It also provides excellent product stability which helps to lower the overall operational costs.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-sl-61-xbb/industrial/en-JP"
        },
        {
            "title":"Hysol 6754",
            "text":"Castrol Hysol™ 6754 (previously named Superedge™ 6754) is a high performance soluble metalworking fluid which is formaldehyde releasing agent, boron and chlorine free. It contains an additive package that works in synergy to enhance machining performance and surface finish, provide excellent product stability, improve bio-resistance properties and lower the overall operations costs.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-6754/industrial/en-JP"
        },
        {
            "title":"Syntilo 77 EF",
            "text":"Oil dispersing, boron and formaldeyhde releasing agent free synthetic coolant which has been developed for general purpose grinding and light to medium duty machining of ferrous and aluminium alloys. Syntilo 77 EF exhibits good anti-corrosion properties coupled with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-77-ef/industrial/en-JP"
        },
        {
            "title":"Almaredge FA",
            "text":"Soluble, chlorine and boron free metalworking fluid for demanding machining of aluminium alloys and low-medium alloyed steel with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-fa/industrial/en-JP"
        },
    ];

    let HighAlloySteelDeepDrilling = [
        {
            "title":"Variocut C 210",
            "text":"A chlorine and heavy metal-free neat cutting oil specially designed with hydrocracked (HC) base oil technology and advanced esters which can help to optimise machining performance on a wide range of light duty general machining applications on ferrous as well as non-ferrous alloys.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-c-210/industrial/en-JP"
        },
        {
            "title":"Almaredge 230",
            "text":"Soluble chlorine free metalworking fluid for general machining of ferrous metals, with excellent system life and foaming properties in soft water.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-230/industrial/en-JP"
        },
        {
            "title":"Syntilo 27",
            "text":"Oil-dispersing synthetic coolant which has been developed for general purpose grinding and light to medium duty machining of ferrous alloys. Syntilo 27 exhibits good anti-corrosion properties coupled with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-27/industrial/en-JP"
        },
        {
            "title":"Hysol SL 35 XBB",
            "text":"Semi-synthetic, chlorine, formaldehyde releasing agent and boron free metalworking fluid for grinding of steel, machining of low-medium alloyed steel and cast iron with excellent anti corrosion and long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-sl-35-xbb/industrial/en-JP"
        },
        {
            "title":"Alusol B",
            "text":"Soluble, chlorine free metalworking fluid for machining of aluminium alloys and low-medium alloyed steel with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-b/industrial/en-JP"
        },
        {
            "title":"CareCut ES 4",
            "text":"A chlorine and heavy metal-free neat cutting oil, based on advanced ester technology. It is used for general machining of ferrous and non-ferrous metals where very high surface finish is required. CareCut ES 4 does not contain active sulphur and is hence compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-4/industrial/en-JP"
        },
    ];

    let HighAlloySteelGrinding = [
        {
            "title":"Almaredge BI",
            "text":"Castrol Almaredge™ BI is a general purpose soluble metalworking fluid which is chlorine and boron-free. It contains a unique additive package that provides good lubrication properties and performs well in a wide water range.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-bi/industrial/en-JP"
        },
        {
            "title":"Syntilo 81 BF",
            "text":"Boron and formaldehye releasing agent free, oil rejecting synthetic coolant developed for use as a general purpose grinding fluid of ferrous alloys. It is extrem low foaming in recommended water conditions and forms a clear, stable solution in both soft and hard water. Syntilo 81 BF shows excellent anti corrosion properties and long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-81-bf/industrial/en-JP"
        },
        {
            "title":"Hysol J 805",
            "text":"Castrol Hysol™ J 805 developed for large scale production of general machining and grinding.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-j-805/industrial/en-JP"
        },
        {
            "title":"Alusol SL 61 XBB",
            "text":"Castrol Alusol™ SL 61 XBB (previously called Alusol RBF) is a high performance semi-synthetic metalworking fluid which is boron, formaldehyde releasing agent and chlorine-free. It contains an additive package that may help to enhance machining performance and surface finish. It also provides excellent product stability which helps to lower the overall operational costs.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-sl-61-xbb/industrial/en-JP"
        },
        {
            "title":"CareCut ES 3",
            "text":"It is designed for severe honing and superfinishing of ferrous and non-ferrous materials. It can also be used for grinding applications, drilling and general machining of aluminium, yellow metals, cast iron and medium alloyed steel. CareCut ES 3 does not contain active sulphur and is hence compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-3/industrial/en-JP"
        },
        {
            "title":"Variocut C 210",
            "text":"A chlorine and heavy metal-free neat cutting oil specially designed with hydrocracked (HC) base oil technology and advanced esters which can help to optimise machining performance on a wide range of light duty general machining applications on ferrous as well as non-ferrous alloys",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-c-210/industrial/en-JP"
        },
    ];

    let HighAlloySteelMilling = [
        {
            "title":"Almaredge BI",
            "text":"Castrol Almaredge™ BI is a general purpose soluble metalworking fluid which is chlorine and boron-free. It contains a unique additive package that provides good lubrication properties and performs well in a wide water range.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-bi/industrial/en-JP"
        },
        {
            "title":"Syntilo 77 EF",
            "text":"Oil dispersing, boron and formaldeyhde releasing agent free synthetic coolant which has been developed for general purpose grinding and light to medium duty machining of ferrous and aluminium alloys. Syntilo 77 EF exhibits good anti-corrosion properties coupled with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-77-ef/industrial/en-JP"
        },
        {
            "title":"Hysol HDM",
            "text":"Soluble, chlorine free metalworking fluid with selected ep-raw materials to overcome severe cutting operations on steel and stainless steel. Product can be used for machining of aluminium alloys too.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-hdm/industrial/en-JP"
        },
        {
            "title":"Alusol MF",
            "text":"Semi-synthetic, chlorine free metalworking fluid for machining of aluminium alloys and low-medium alloyed steel with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-mf/industrial/en-JP"
        },
        {
            "title":"CareCut ES 2",
            "text":"It is designed for high speed, creep feed and gear grinding of ferrous and non-ferrous metals including titanium & other super alloys. It can also be used for drilling and general machining applications, as well as for hard metal and tool grinding. CareCut ES 2 does not contain active sulphur and is hence compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-2/industrial/en-JP"
        },
        {
            "title":"Variocut C 260 S",
            "text":"A chlorine and heavy metal-free, high flash point neat cutting oil, based on advanced ester technology to help optimise machining performance and enhance surface finish. It is specially developed for general machining of cast iron, low-medium alloy steel, high alloy steel and stainless steel. It can also be used for machining non-ferrous alloys including aluminium, yellow metals and tough to machine materials like titanium alloys. Variocut C 260 S does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-c-260-s/industrial/en-JP"
        },
    ];

    let HighAlloySteelDrilling = [
        {
            "title":"Almaredge FA",
            "text":"Soluble, chlorine and boron free metalworking fluid for demanding machining of aluminium alloys and low-medium alloyed steel with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-fa/industrial/en-JP"
        },
        {
            "title":"Syntilo 2110",
            "text":"Formaldehye releasing agent free synthetic coolant which has been developed for general purpose grinding and light duty machining of ferrous alloys. It forms a clear, stable solution in both hard and soft waters. Syntilo 2110 exhibits good anti-corrosion properties coupled with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-2110/industrial/en-JP"
        },
        {
            "title":"Hysol 701 EF",
            "text":"Castrol Hysol™ 701 EF (previously called Clearedge™ 701 EF)is a high performance semi-synthetic metalworking fluid which is boron, formaldeyhde releasing agent and chlorine free. It contains an additive package that works in synergy to enhance machining performance and surface finish, provide excellent product stability, improve bio-resistance properties and lower the overall operations costs.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-701-ef/industrial/en-JP"
        },
        {
            "title":"Alusol B",
            "text":"Soluble, chlorine free metalworking fluid for machining of aluminium alloys and low-medium alloyed steel with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-b/industrial/en-JP"
        },
        {
            "title":"Variocut B 46 TC",
            "text":"A chlorine and heavy metal free neat cutting oil specially formulated with a special combination of ester, extreme pressure (EP) and anti-wear additives to help to optimise machining performance and enhance tool life. It is designed for severe broaching and gear cutting of high alloy steel and stainless steel. Variocut B 46 TC contains active sulphur and is not compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-b-46-tc/industrial/en-JP"
        },
        
    ];

    let HighAlloySteelSuperfinishing = [
        {
            "title":"Honilo 930",
            "text":"A chlorine and heavy metal free, low viscosity neat cutting oil specially designed for honing and superfinishing of ferrous and non-ferrous materials. Honilo 430 does not contain active sulphur and is compatible with yellow metals",
            "link":"https://thelubricantoracle.castrol.com/product/honilo-930/industrial/en-JP"
        },
        {
            "title":"Honilo 981",
            "text":"A chlorine and heavy metal free low viscosity neat cutting oil for honing and superfinishing of cast iron, steel and aluminium alloys, where critical dimensional accuracy are required.",
            "link":"https://thelubricantoracle.castrol.com/product/honilo-981/industrial/en-JP"
        },
        {
            "title":"Honilo 988",
            "text":"A chlorine and heavy metal free low viscosity neat cutting oil specially designed for honing and superfinishing of ferrous and non-ferrous materials. It is specially designed to inhibit staining where sulphurised honing sticks are used and to improve in-process corrosion protection for the bearing industry. Honilo 988 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/honilo-988/industrial/en-JP"
        },
        
    ];

    let AluminumBroaching = [
        {
            "title":"Variocut B 30",
            "text":"A chlorine free neat cutting oil specially formulated with a special combination of ester, extreme pressure (EP) and anti-wear additives to help to optimise machining performance and enhance tool life. It is designed for severe broaching and gear cutting of high alloy steel and stainless steel. Variocut B 30 contains active sulphur and is not compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-b-30/industrial/en-JP"
        },
        {
            "title":"Variocut B 40",
            "text":"A chlorine and heavy metal free neat cutting oil specially formulated with a special combination of esters and performance additives to enhance tool life for the most severe machining applications. It is designed for broaching and gear cutting of alloy steel, stainless steel as well as non-ferrous materials. Variocut B 40 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-b-40/industrial/en-JP"
        },
        {
            "title":"Variocut C 462",
            "text":"A chlorine free neat cutting oil developed using highly refined base oils and ester additives which can help to provide excellent machininig performance and enhanced surface finish. It is recommended for general machining of non-ferrous material specially copper and aluminum alloys. Variocut C 462 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-c-462/industrial/en-JP"
        },
        {
            "title":"ALUSOL CBF",
            "text":"Soluble metalworking fluid for machining of aluminium alloys and low-medium alloyed steel",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-cbf/industrial/en-JP"
        },
        {
            "title":"ALUSOL RBF",
            "text":"Semi-synthetic, boron-free metalworking fluid for machining of aluminium alloys and low-medium alloyed steel",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-rbf/industrial/en-JP"
        },
        {
            "title":"SYNTILO 2000",
            "text":"Synthetic coolant for general purpose grinding, honing and heavy duty machining on ferrous alloys",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-2000/industrial/en-JP"
        },
        {
            "title":"SYNTILO 9904",
            "text":"Synthetic coolant for use general purpose grinding and medium to heavy duty machining on ferrous alloys",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-9904/industrial/en-JP"
        },
    ];

    let AluminumDeepDrilling = [
        {
            "title":"Variocut C 260 S",
            "text":"High flash point ester based neat cutting oil for all general machining and drilling applications of ferrous and non-ferrous metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-c-260-s/industrial/en-JP"
        },
        {
            "title":"Variocut C 334",
            "text":"Neat cutting oil for deep drilling of cast iron and low to medium alloyed steels.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-c-334/industrial/en-JP"
        },
        {
            "title":"HYSOL 6754",
            "text":"Castrol Hysol™ 6754 (previously named Superedge™ 6754) is a high performance soluble metalworking fluid which is formaldehyde releasing agent, boron and chlorine free. It contains an additive package that works in synergy to enhance machining performance and surface finish, provide excellent product stability, improve bio-resistance properties and lower the overall operations costs.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-6754/industrial/en-JP"
        },
        {
            "title":"HYSOL HDM",
            "text":"Soluble metalworking fluid for machining of low-medium alloyed steel, high alloyed steel, stainless steel and aluminium alloys.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-hdm/industrial/en-JP"
        },
        {
            "title":"SYNTILO 77 EF ",
            "text":"Synthetic coolant which has been developed for general purpose grinding and light to medium duty machining of ferrous and aluminum alloys.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-77-ef/industrial/en-JP"
        },
        {
            "title":"SYNTILO 9918",
            "text":"Synthetic pH neutral coolant for cutting and grinding of ferrous and aluminium alloys.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-9918/industrial/en-JP"
        },
    ];

    let AluminumGrinding = [
        {
            "title":"HYSOL 6754",
            "text":"Castrol Hysol™ 6754 (previously named Superedge™ 6754) is a high performance soluble metalworking fluid which is formaldehyde releasing agent, boron and chlorine free. It contains an additive package that works in synergy to enhance machining performance and surface finish, provide excellent product stability, improve bio-resistance properties and lower the overall operations costs.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-6754/industrial/en-JP"
        },
        {
            "title":"HYSOL MB 50",
            "text":"Soluble metalworking fluid for machining of aluminium alloys, low-medium alloyed , high alloyed steel and cast iron",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-mb-50/industrial/en-JP"
        },
        {
            "title":"CARECUT ES 3",
            "text":"High flash point ester based neat cutting oil for honing and superfinishing of ferrous and non-ferrous metals",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-3/industrial/en-JP"
        },
        {
            "title":"CARECUT S 600",
            "text":"Soluble ester based metalworking fluid for machining of aluminium alloys and steel.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-s-600/industrial/en-JP"
        },
        
    ];

    let AluminumMilling = [
        {
            "title":"ILOCUT 11",
            "text":"High performance neat cutting oil",
            "link":"https://thelubricantoracle.castrol.com/product/ilocut-11/industrial/en-JP"
        },
        {
            "title":"ILOCUT 486",
            "text":"Chlorinated neat cutting oil for general machining, grinding, broaching and gear cutting of high alloyed steels and non-ferrous metals.",
            "link":"https://thelubricantoracle.castrol.com/product/ilocut-486/industrial/en-JP"
        },
        {
            "title":"ALMAREDGE 230",
            "text":"Soluble metalworking fluid for grinding of steel, machining of low-medium alloyed steel and cast iron.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-230/industrial/en-JP"
        },
        {
            "title":"ALMAREDGE BI",
            "text":"General purpose soluble metalworking fluid",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-bi/industrial/en-JP"
        },
        {
            "title":"SYNTILO 77 EF ",
            "text":"Synthetic coolant which has been developed for general purpose grinding and light to medium duty machining of ferrous and aluminum alloys.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-77-ef/industrial/en-JP"
        },
        {
            "title":"SYNTILO 9913",
            "text":"Synthetic pH-neutral coolant for heavy duty machining and grinding of aluminum and other aerospace alloys.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-9913/industrial/en-JP"
        },
    ];
    
    let AluminumDrilling = [
        {
            "title":"VARIOCUT D 734",
            "text":"Neat cutting oil for deep drilling for all ferrous metals, stainless steel and difficult alloys like inconel.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-d-734/industrial/en-JP"
        },
        {
            "title":"VARIOCUT C 337",
            "text":"Neat cutting oil for deep drilling of cast iron and low to medium alloyed steels.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-c-337/industrial/en-JP"
        },
        {
            "title":"SYNTILO 75 EF",
            "text":"Synthetic coolant which has been developed for general purpose grinding and light to medium duty machining of ferrous alloys.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-75-ef/industrial/en-JP"
        },
        {
            "title":"SYNTILO 9930 BF",
            "text":"Synthetic coolant which has been developed for general purpose grinding and light to medium duty machining of ferrous alloys.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-9930-bf/industrial/en-JP"
        },
        
    ];

    let AluminumSuperfinishing = [
        {
            "title":"Honilo 930",
            "text":"A chlorine and heavy metal free, low viscosity neat cutting oil specially designed for honing and superfinishing of ferrous and non-ferrous materials. Honilo 430 does not contain active sulphur and is compatible with yellow metals",
            "link":"https://thelubricantoracle.castrol.com/product/honilo-930/industrial/en-JP"
        },
        {
            "title":"Honilo 981",
            "text":"A chlorine and heavy metal free low viscosity neat cutting oil for honing and superfinishing of cast iron, steel and aluminium alloys, where critical dimensional accuracy are required.",
            "link":"https://thelubricantoracle.castrol.com/product/honilo-981/industrial/en-JP"
        },
        {
            "title":"Honilo 988",
            "text":"A chlorine and heavy metal free low viscosity neat cutting oil specially designed for honing and superfinishing of ferrous and non-ferrous materials. It is specially designed to inhibit staining where sulphurised honing sticks are used and to improve in-process corrosion protection for the bearing industry. Honilo 988 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/honilo-988/industrial/en-JP"
        },
        
    ];

    let LowAlloySteelBroaching = [
        {
            "title":"Variocut B 27",
            "text":"A chlorine and heavy metal free neat cutting oil specially formulated with a special combination of ester, extreme pressure (EP) and anti-wear additives to help to optimise",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-b-27/industrial/en-JP"
        },
        {
            "title":"Ilocut 11",
            "text":"Castrol Ilocut™ 11 is a highly chlorinated, sulphur and heavy metal free neat cutting oil.",
            "link":"https://thelubricantoracle.castrol.com/product/ilocut-11/industrial/en-JP"
        },
        {
            "title":"Variocut B 40",
            "text":"A chlorine and heavy metal free neat cutting oil specially formulated with a special combination of esters and performance additives to enhance tool life for the most severe machining applications. It is designed for broaching and gear cutting of alloy steel, stainless steel as well as non-ferrous materials. Variocut B 40 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-b-40/industrial/en-JP"
        },
        {
            "title":"CareCut ES 1",
            "text":"A chlorine and heavy metal-free neat cutting oil, based on advanced ester technology.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-1/industrial/en-JP"
        },
        {
            "title":"CareCut S 600",
            "text":"Soluble, chlorine free metalworking fluid based on selected ester technology for machining of aluminium alloys and steel with long system life and excellent anti foam properties in soft water.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-s-600/industrial/en-JP"
        },
        {
            "title":"Ilocut 219",
            "text":"Castrol Ilocut™ 219 (previously named Ilobroach 219) is a high performance chlorinated and fatted metalworking lubricant especially developed for precision form tool operations such as broaching and gear cutting of difficult to machine alloys and stainless steels.",
            "link":"https://thelubricantoracle.castrol.com/product/ilocut-219/industrial/en-JP"
        }
    ];

    let LowAlloySteelDeepDrilling = [
        {
            "title":"Variocut C 260 S",
            "text":"A chlorine and heavy metal-free, high flash point neat cutting oil, based on advanced ester technology to help optimise machining performance and enhance surface finish. It is specially developed for general machining of cast iron, low-medium alloy steel, high alloy steel and stainless steel. It can also be used for machining non-ferrous alloys including aluminium, yellow metals and tough to machine materials like titanium alloys. Variocut C 260 S does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-c-260-s/industrial/en-JP"
        },
        {
            "title":"Almaredge FA",
            "text":"Soluble, chlorine and boron free metalworking fluid for demanding machining of aluminium alloys and low-medium alloyed steel with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-fa/industrial/en-JP"
        },
        {
            "title":"CareCut ES 3",
            "text":"It is designed for severe honing and superfinishing of ferrous and non-ferrous materials. It can also be used for grinding applications, drilling and general machining of aluminium, yellow metals, cast iron and medium alloyed steel. CareCut ES 3 does not contain active sulphur and is hence compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-3/industrial/en-JP"
        },
        {
            "title":"Syntilo 2110",
            "text":"Formaldehye releasing agent free synthetic coolant which has been developed for general purpose grinding and light duty machining of ferrous alloys. It forms a clear, stable solution in both hard and soft waters. Syntilo 2110 exhibits good anti-corrosion properties coupled with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-2110/industrial/en-JP"
        },

    ];

    let LowAlloySteelGrinding = [
        {
            "title":"Variocut G 500",
            "text":"A chlorine and heavy metal free neat cutting oil formulated with high quality base oils and anti-wear additives for flute, form and gear grinding with carborundum and SG wheels. It is specially recommended for tungsten carbide and tool grinding applications. Variocut G 500 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-g-500/industrial/en-JP"
        },
        {
            "title":"CareCut S 600",
            "text":"Soluble, chlorine free metalworking fluid based on selected ester technology for machining of aluminium alloys and steel with long system life and excellent anti foam properties in soft water.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-s-600/industrial/en-JP"
        },
        {
            "title":"Variocut B 40",
            "text":"A chlorine and heavy metal free neat cutting oil specially formulated with a special combination of esters and performance additives to enhance tool life for the most severe machining applications. It is designed for broaching and gear cutting of alloy steel, stainless steel as well as non-ferrous materials. Variocut B 40 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-b-40/industrial/en-JP"
        },
        {
            "title":"CareCut ES 3",
            "text":"It is designed for severe honing and superfinishing of ferrous and non-ferrous materials. It can also be used for grinding applications, drilling and general machining of aluminium, yellow metals, cast iron and medium alloyed steel. CareCut ES 3 does not contain active sulphur and is hence compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-3/industrial/en-JP"
        },
        {
            "title":"Ilocut 510 MP",
            "text":"A chlorine and heavy metal free, multi-purpose neat cutting oil. Formulated from highly refined base oils, it can also be used as a hydraulic oil confirming to ISO 6743/4 Type HM and DIN 51502 Class HLP-D specification.",
            "link":"https://thelubricantoracle.castrol.com/product/ilocut-510-mp/industrial/en-JP "
        },
        {
            "title":"Alusol J 607",
            "text":"Semi-synthetic, chlorine and boron free metalworking fluid for demanding machining of aluminium alloys and low-medium alloyed steel with good low foaming properties in soft water.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-j-607/industrial/en-JP"
        },
        {
            "title":"Ilocut 522 MP",
            "text":"A chlorine and heavy metal free, multi-purpose neat cutting oil, formulated from highly refined base oils. It is designed for grinding, drilling and general machining of ferrous as well as non-ferrous materials including yellow metals. Ilocut 522 MP can also be used as a hydraulic oil confirming to ISO 6743/4 Type HM and DIN 51502 Class HLP-D specification.",
            "link":"https://thelubricantoracle.castrol.com/product/ilocut-522-mp/industrial/en-JP"
        }
    ];

    let LowAlloySteelMilling= [
        {
            "title":"Ilocut 154",
            "text":"A chlorine and heavy metal free neat cutting oil developed using highly refined base oils and extreme pressure (EP) additives for optimised machining performance. It can be used for general purpose machining of cast iron, medium and high alloyed steel and non-ferrous metals including copper and aluminum alloys. Ilocut 154 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/ilocut-154/industrial/en-JP"
        },
        {
            "title":"CareCut ES 4",
            "text":"A chlorine and heavy metal-free neat cutting oil, based on advanced ester technology. It is used for general machining of ferrous and non-ferrous metals where very high surface finish is required. CareCut ES 4 does not contain active sulphur and is hence compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-4/industrial/en-JP"
        },
        {
            "title":"Alusol CFB",
            "text":"Soluble, chlorine free metalworking fluid for machining of aluminium alloys and low-medium alloyed steel with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-cfb/industrial/en-JP"
        },
        {
            "title":"Variocut G 500",
            "text":"A chlorine and heavy metal free neat cutting oil formulated with high quality base oils and anti-wear additives for flute, form and gear grinding with carborundum and SG wheels. It is specially recommended for tungsten carbide and tool grinding applications. Variocut G 500 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-g-500/industrial/en-JP"
        },
        {
            "title":"Ilocut 5721",
            "text":"Chlorine free neat cutting oil for general machining of stainless steel, high alloyed steel, nickel, titanium and non-ferrous metals.",
            "link":"https://thelubricantoracle.castrol.com/product/ilocut-5721/industrial/en-JP"
        },
        {
            "title":"Almaredge AL",
            "text":"Soluble, chlorine and boron free metalworking fluid for demanding machining of aluminium alloys and low-medium alloyed steel with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-al/industrial/en-JP"
        },
    ];

    let LowAlloySteelDrilling= [
        {
            "title":"Variocut B 46 TC",
            "text":"A chlorine and heavy metal free neat cutting oil specially formulated with a special combination of ester, extreme pressure (EP) and anti-wear additives to help to optimise machining performance and enhance tool life. It is designed for severe broaching and gear cutting of high alloy steel and stainless steel. Variocut B 46 TC contains active sulphur and is not compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-b-46-tc/industrial/en-JP"
        },
        {
            "title":"CareCut ES 4",
            "text":"A chlorine and heavy metal-free neat cutting oil, based on advanced ester technology. It is used for general machining of ferrous and non-ferrous metals where very high surface finish is required. CareCut ES 4 does not contain active sulphur and is hence compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-4/industrial/en-JP"
        },
        {
            "title":"Alusol RBF",
            "text":"Semi-synthetic chlorine, boron and formaldehyde releasing agent free metalworking fluid for severe machining of aluminium and low-medium alloyed steel with good low foaming properties.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-rbf/industrial/en-JP"
        },
        {
            "title":"Syntilo 1023 BF",
            "text":"Boron and formaldehyde releasing agent free, oil-dispersing synthetic cutting and grinding fluid formulated for use in cast iron transfer lines. Syntilo 1023 is engineered to separate tramp oil to the surface of the fluid where it can be removed by skimming. It also disperses small amounts of oil throughout the fluid to create a thin film which protects parts, chips and machine surfaces. This oil-dispersing characteristic reduces corrosion and prevents clinkering.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-1023-bf/industrial/en-JP"
        },
        {
            "title":"Almaredge 750",
            "text":"Semi-synthetic, chlorine and boron free metalworking fluid for grinding of steel and machining of cast iron with good cleanability.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-750/industrial/en-JP"
        }
    ];

    let LowAlloySteelSuperfinishing= [
        {
            "title":"Honilo 930",
            "text":"A chlorine and heavy metal free neat cutting oil specially formulated with a special combination of ester, extreme pressure (EP) and anti-wear additives to help to optimise machining performance and enhance tool life. It is designed for severe broaching and gear cutting of high alloy steel and stainless steel. Variocut B 46 TC contains active sulphur and is not compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-b-46-tc/industrial/en-JP"
        },
        {
            "title":"Honilo 981",
            "text":"A chlorine and heavy metal free low viscosity neat cutting oil for honing and superfinishing of cast iron, steel and aluminium alloys, where critical dimensional accuracy are required.",
            "link":"https://thelubricantoracle.castrol.com/product/honilo-981/industrial/en-JP"
        },
        {
            "title":"Honilo 988",
            "text":"A chlorine and heavy metal free low viscosity neat cutting oil specially designed for honing and superfinishing of ferrous and non-ferrous materials. It is specially designed to inhibit staining where sulphurised honing sticks are used and to improve in-process corrosion protection for the bearing industry. Honilo 988 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/honilo-988/industrial/en-JP"
        }
    ];

    let YellowMetalBroaching = [
        {
            "title":"Almaredge 230",
            "text":"Soluble chlorine free metalworking fluid for general machining of ferrous metals, with excellent system life and foaming properties in soft water.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-230/industrial/en-JP"
        },
        {
            "title":"Ilocut 11",
            "text":"Castrol Ilocut™ 11 is a highly chlorinated, sulphur and heavy metal free neat cutting oil.",
            "link":"https://thelubricantoracle.castrol.com/product/ilocut-11/industrial/en-JP"
        },
        {
            "title":"Variocut B 40",
            "text":"A chlorine and heavy metal free neat cutting oil specially formulated with a special combination of esters and performance additives to enhance tool life for the most severe machining applications. It is designed for broaching and gear cutting of alloy steel, stainless steel as well as non-ferrous materials. Variocut B 40 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-b-40/industrial/en-JP"
        },
        {
            "title":"CareCut ES 1",
            "text":"A chlorine and heavy metal-free neat cutting oil, based on advanced ester technology.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-1/industrial/en-JP"
        },
        {
            "title":"CareCut S 600",
            "text":"Soluble, chlorine free metalworking fluid based on selected ester technology for machining of aluminium alloys and steel with long system life and excellent anti foam properties in soft water.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-s-600/industrial/en-JP"
        },
        {
            "title":"Alusol B",
            "text":"Soluble, chlorine free metalworking fluid for machining of aluminium alloys and low-medium alloyed steel with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-b/industrial/en-JP"
        },
        {
            "title":"Hysol 6754",
            "text":"Castrol HysolTM SL 45 XBB is a high performance soluble metalworking fluid which is boron, formaldehyde releasing agent and chlorine free.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-6754/industrial/en-JP"
        }
    ];

    let YellowMetalDeepDrilling = [
        {
            "title":"Almaredge AL",
            "text":"Soluble, chlorine and boron free metalworking fluid for demanding machining of aluminium alloys and low-medium alloyed steel with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-al/industrial/en-JP"
        },
        {
            "title":"Alusol J 607",
            "text":"Semi-synthetic, chlorine and boron free metalworking fluid for demanding machining of aluminium alloys and low-medium alloyed steel with good low foaming properties in soft water.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-j-607/industrial/en-JP"
        },
        {
            "title":"CareCut ES 3",
            "text":"It is designed for severe honing and superfinishing of ferrous and non-ferrous materials. It can also be used for grinding applications, drilling and general machining of aluminium, yellow metals, cast iron and medium alloyed steel. CareCut ES 3 does not contain active sulphur and is hence compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-3/industrial/en-JP"
        },
        {
            "title":"Hysol MB 50",
            "text":"Soluble, chlorine and formaldehyde releasing agent free metalworking fluid for ferrous and aluminium machining. A multi metal purpose product with good aluminium compatibility and long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-mb-50/industrial/en-JP"
        },
        {
            "title":"Variocut D 734",
            "text":"A chlorine and heavy metal free neat cutting oil developed using highly refined base oil and extreme pressure (EP) additives and designed for most difficult drilling operations. It can be used for drilling inlcuding deep drilling of alloy steel, stainless steel and inconel materials. Variocut D 734 contains active sulphur and is not compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-d-734/industrial/en-JP"
        },
        {
            "title":"Syntilo 77 EF",
            "text":"Oil dispersing, boron and formaldeyhde releasing agent free synthetic coolant which has been developed for general purpose grinding and light to medium duty machining of ferrous and aluminium alloys. Syntilo 77 EF exhibits good anti-corrosion properties coupled with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-77-ef/industrial/en-JP"
        },

    ];

    let YellowMetalGrinding = [
        {
            "title":"Ilocut 515 MP",
            "text":"A chlorine and heavy metal free, multi-purpose neat cutting oil. Formulated from highly refined base oils, it can also be used as a hydraulic oil confirming to ISO 6743/4 Type HM and DIN 51502 Class HLP-D specification",
            "link":"https://thelubricantoracle.castrol.com/product/ilocut-515-mp/industrial/en-JP"
        },
        {
            "title":"Hysol SL 45 XBB",
            "text":"Castrol HysolTM SL 45 XBB is a high performance soluble metalworking fluid which is boron, formaldehyde releasing agent and chlorine free.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-sl-45-xbb/industrial/en-JP"
        },
        {
            "title":"Variocut G 600 HC",
            "text":"A chlorine and heavy metal free neat cutting oil specially designed with high quality hydrocracked (HC) base oil technology and a special anti-wear additive package for optimum performance on high speed, creep feed and gear grinding using carborundum and CBN wheels. It is a versatile multi-application and multi-metal machining product, also compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-g-600-hc/industrial/en-JP"
        },
        {
            "title":"Syntilo 9913",
            "text":"pH-neutral, boron and formaldeyhyde releasing agent free, oil rejecting synthetic coolant developed for heavy duty machining and grinding of aluminum and other aerospace alloys. Syntilo 9913 contains a combination of surfactant chemistry which will provide excellent lubrication and cooling properties. It is low foaming in recommended water conditions and shows long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-9913/industrial/en-JP"
        },
        {
            "title":"CareCut ES 3",
            "text":"It is designed for severe honing and superfinishing of ferrous and non-ferrous materials. It can also be used for grinding applications, drilling and general machining of aluminium, yellow metals, cast iron and medium alloyed steel. CareCut ES 3 does not contain active sulphur and is hence compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-3/industrial/en-JP"
        },

    ];

    let YellowMetalMilling= [
        {
            "title":"Almaredge FA",
            "text":"Soluble, chlorine and boron free metalworking fluid for demanding machining of aluminium alloys and low-medium alloyed steel with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-fa/industrial/en-JP"
        },
        {
            "title":"Hysol J 805",
            "text":"Castrol Hysol™ J 805 (previously called Clearedge™ J 805) is developed for large scale production of general machining and grinding.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-j-805/industrial/en-JP"
        },
        {
            "title":"CareCut ES 1",
            "text":"It is designed for severe honing and superfinishing of ferrous and non-ferrous materials. It can also be used for grinding applications, drilling and general machining of aluminium, yellow metals, cast iron and medium alloyed steel. CareCut ES 3 does not contain active sulphur and is hence compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-1/industrial/en-JP"
        },
        {
            "title":"Variocut G 500",
            "text":"A chlorine and heavy metal free neat cutting oil formulated with high quality base oils and anti-wear additives for flute, form and gear grinding with carborundum and SG wheels. It is specially recommended for tungsten carbide and tool grinding applications. Variocut G 500 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-g-500/industrial/en-JP"
        },
        {
            "title":"Ilocut 5721",
            "text":"Chlorine free neat cutting oil for general machining of stainless steel, high alloyed steel, nickel, titanium and non-ferrous metals.",
            "link":"https://thelubricantoracle.castrol.com/product/ilocut-5721/industrial/en-JP"
        },
        {
            "title":"Syntilo 75 EF",
            "text":"Oil dispersing, boron and formaldeyhde releasing agent free synthetic coolant which has been developed for general purpose grinding and light to medium duty machining for ferrous alloys. Syntilo 75 EF exhibits good anti-corrosion properties coupled with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-75-ef/industrial/en-JP"
        },
    ];

    let YellowMetalDrilling= [
        {
            "title":"Almaredge BI",
            "text":"Castrol Almaredge™ BI is a general purpose soluble metalworking fluid which is chlorine and boron-free.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-bi/industrial/en-JP"
        },
        {
            "title":"Syntilo 2000",
            "text":"Boron and formaldeyhde releasing agent free, synthetic coolant for general purpose grinding, honing and heavy duty machining on ferrous alloys. It is low foaming in recommended water conditions and forms a clear, stable solution in both soft and hard water. Syntilo 2000 shows good anti corrosion properties and long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-2000/industrial/en-JP"
        },
        {
            "title":"Alusol RBF",
            "text":"Semi-synthetic chlorine, boron and formaldehyde releasing agent free metalworking fluid for severe machining of aluminium and low-medium alloyed steel with good low foaming properties.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-rbf/industrial/en-JP"
        },
        {
            "title":"Ilocut 219",
            "text":"Castrol Ilocut™ 219 (previously named Ilobroach 219) is a high performance chlorinated and fatted metalworking lubricant especially developed for precision form tool operations such as broaching and gear cutting of difficult to machine alloys and stainless steels.",
            "link":"https://thelubricantoracle.castrol.com/product/ilocut-219/industrial/en-JP"
        },
        {
            "title":"Hysol J 805",
            "text":"Castrol Hysol™ J 805 (previously called Clearedge™ J 805) is developed for large scale production of general machining and grinding.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-j-805/industrial/en-JP"
        },
        {    
            "title":"Alusol RAL BF J",
            "text":"Semi-synthetc, chlorine, boron and formaldehyde releasing agent free metalworking fluid for demanding machining of aluminium alloys and low-medium alloyed steel with good system life.",
            "link":"https://thelubricantoracle.castrol.com/product/alusol-ral-bf-j/industrial/en-JP"
        },
    ];

    let YellowMetalSuperfinishing= [
        {
            "title":"Honilo 930",
            "text":"A chlorine and heavy metal free neat cutting oil specially formulated with a special combination of ester, extreme pressure (EP) and anti-wear additives to help to optimise machining performance and enhance tool life. It is designed for severe broaching and gear cutting of high alloy steel and stainless steel. Variocut B 46 TC contains active sulphur and is not compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-b-46-tc/industrial/en-JP"
        },
        {
            "title":"Honilo 981",
            "text":"A chlorine and heavy metal free low viscosity neat cutting oil for honing and superfinishing of cast iron, steel and aluminium alloys, where critical dimensional accuracy are required.",
            "link":"https://thelubricantoracle.castrol.com/product/honilo-981/industrial/en-JP"
        },
        {
            "title":"Honilo 988",
            "text":"A chlorine and heavy metal free low viscosity neat cutting oil specially designed for honing and superfinishing of ferrous and non-ferrous materials. It is specially designed to inhibit staining where sulphurised honing sticks are used and to improve in-process corrosion protection for the bearing industry. Honilo 988 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/honilo-988/industrial/en-JP"
        }
    ];

    let OtherAlloysBroaching = [
        {
            "title":"Variocut B 46 TC",
            "text":"A chlorine and heavy metal free neat cutting oil specially formulated with a special combination of ester, extreme pressure (EP) and anti-wear additives to help to optimise machining performance and enhance tool life. It is designed for severe broaching and gear cutting of high alloy steel and stainless steel. Variocut B 46 TC contains active sulphur and is not compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-b-46-tc/industrial/en-JP"
        },
        {
            "title":"Hysol 6754",
            "text":"Castrol Hysol™ 6754 (previously named Superedge™ 6754) is a high performance soluble metalworking fluid which is formaldehyde releasing agent, boron and chlorine free.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-6754/industrial/en-JP"
        },
        {
            "title":"Almaredge 230",
            "text":"Soluble chlorine free metalworking fluid for general machining of ferrous metals, with excellent system life and foaming properties in soft water.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-230/industrial/en-JP"
        },
        {
            "title":"CareCut ES 1",
            "text":"A chlorine and heavy metal-free neat cutting oil, based on advanced ester technology.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-1/industrial/en-JP"
        },
    ];

    let OtherAlloyDeepDrilling = [
        {
            "title":"Syntilo 1023 BF",
            "text":"Boron and formaldehyde releasing agent free, oil-dispersing synthetic cutting and grinding fluid formulated for use in cast iron transfer lines. Syntilo 1023 is engineered to separate tramp oil to the surface of the fluid where it can be removed by skimming. It also disperses small amounts of oil throughout the fluid to create a thin film which protects parts, chips and machine surfaces. This oil-dispersing characteristic reduces corrosion and prevents clinkering.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-1023-bf/industrial/en-JP"
        },
        {
            "title":"Variocut C 260 S",
            "text":"A chlorine and heavy metal-free, high flash point neat cutting oil, based on advanced ester technology to help optimise machining performance and enhance surface finish. It is specially developed for general machining of cast iron, low-medium alloy steel, high alloy steel and stainless steel. It can also be used for machining non-ferrous alloys including aluminium, yellow metals and tough to machine materials like titanium alloys. Variocut C 260 S does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-c-260-s/industrial/en-JP"
        },
        {
            "title":"Hysol HDM",
            "text":"Soluble, chlorine free metalworking fluid with selected ep-raw materials to overcome severe cutting operations on steel and stainless steel. Product can be used for machining of aluminium alloys too.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-hdm/industrial/en-JP"
        },
        {
            "title":"Almaredge BI",
            "text":"Castrol Almaredge™ BI is a general purpose soluble metalworking fluid which is chlorine and boron-free",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-bi/industrial/en-JP"
        },
    ];

    let OtherAlloysGrinding = [
        {
            "title":"Variocut G 500",
            "text":"A chlorine and heavy metal free neat cutting oil formulated with high quality base oils and anti-wear additives for flute, form and gear grinding with carborundum and SG wheels. It is specially recommended for tungsten carbide and tool grinding applications. Variocut G 500 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-g-500/industrial/en-JP"
        },
        {
            "title":"Syntilo 2000",
            "text":"Boron and formaldeyhde releasing agent free, synthetic coolant for general purpose grinding, honing and heavy duty machining on ferrous alloys. It is low foaming in recommended water conditions and forms a clear, stable solution in both soft and hard water. Syntilo 2000 shows good anti corrosion properties and long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-2000/industrial/en-JP"
        },
        {
            "title":"Hysol SL 37 XBB",
            "text":"Semi-synthetic metalworking fluid, formulated without formaldehyde releasing agent and boron for machining of steel, cast iron and aluminum alloys with excellent long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-sl-37-xbb/industrial/en-JP"
        },
        {
            "title":"Syntilo 25",
            "text":"Formaldehye releasing agent free synthetic coolant which has been developed for general purpose grinding and light to medium duty machining of ferrous alloys. It forms a clear, stable solution in both hard and soft waters. Syntilo 25 exhibits good anti-corrosion properties coupled with long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-25/industrial/en-JP"
        },

    ];

    let OtherAlloysMilling= [
        {
            "title":"HYSOL J 805",
            "text":"Castrol Hysol™ J 805 (previously called Clearedge™ J 805) is developed for large scale production of general machining and grinding",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-j-805/industrial/en-JP"
        },
        {
            "title":"CareCut ES 1",
            "text":"It is designed for severe honing and superfinishing of ferrous and non-ferrous materials. It can also be used for grinding applications, drilling and general machining of aluminium, yellow metals, cast iron and medium alloyed steel. CareCut ES 3 does not contain active sulphur and is hence compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-1/industrial/en-JP"
        },
        {
            "title":"Variocut G 500",
            "text":"A chlorine and heavy metal free neat cutting oil formulated with high quality base oils and anti-wear additives for flute, form and gear grinding with carborundum and SG wheels. It is specially recommended for tungsten carbide and tool grinding applications. Variocut G 500 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-g-500/industrial/en-JP"
        },
        {
            "title":"Ilocut 219",
            "text":"Castrol Ilocut™ 219 (previously named Ilobroach 219) is a high performance chlorinated and fatted metalworking lubricant especially developed for precision form tool operations such as broaching and gear cutting of difficult to machine alloys and stainless steels.",
            "link":"https://thelubricantoracle.castrol.com/product/ilocut-219/industrial/en-JP"
        },
        {
            "title":"Syntilo 9904",
            "text":"Formaldeyhde releasing agent free, oil rejecting synthetic coolant for general purpose grinding and medium to heavy duty machining of ferrous alloys. It is low foaming in recommended water conditions and forms a clear, stable solution in both soft and hard water. Syntilo 9904 shows good anti corrosion properties and long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-9904/industrial/en-JP"
        },
    ];

    let OtherAlloysDrilling= [
        {
            "title":"Almaredge BI",
            "text":"Castrol Almaredge™ BI is a general purpose soluble metalworking fluid which is chlorine and boron-free.",
            "link":"https://thelubricantoracle.castrol.com/product/almaredge-bi/industrial/en-JP"
        },
        {
            "title":"Syntilo 2000",
            "text":"Boron and formaldeyhde releasing agent free, synthetic coolant for general purpose grinding, honing and heavy duty machining on ferrous alloys. It is low foaming in recommended water conditions and forms a clear, stable solution in both soft and hard water. Syntilo 2000 shows good anti corrosion properties and long system life.",
            "link":"https://thelubricantoracle.castrol.com/product/syntilo-2000/industrial/en-JP"
        },
        {
            "title":"Variocut C 260 S",
            "text":"A chlorine and heavy metal-free, high flash point neat cutting oil, based on advanced ester technology to help optimise machining performance and enhance surface finish. It is specially developed for general machining of cast iron, low-medium alloy steel, high alloy steel and stainless steel. It can also be used for machining non-ferrous alloys including aluminium, yellow metals and tough to machine materials like titanium alloys. Variocut C 260 S does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-c-260-s/industrial/en-JP"
        },
        {
            "title":"Ilocut 219",
            "text":"Castrol Ilocut™ 219 (previously named Ilobroach 219) is a high performance chlorinated and fatted metalworking lubricant especially developed for precision form tool operations such as broaching and gear cutting of difficult to machine alloys and stainless steels.",
            "link":"https://thelubricantoracle.castrol.com/product/ilocut-219/industrial/en-JP"
        },
        {
            "title":"Hysol X",
            "text":"Soluble, chlorine free metalworking fluid with selected ep-raw materials for machining of ferrous and aluminium alloys. A multi metal product with excellent low foaming properties in soft water.",
            "link":"https://thelubricantoracle.castrol.com/product/hysol-x/industrial/en-JP"
        },
        {    
            "title":"CareCut ES 2",
            "text":"It is designed for high speed, creep feed and gear grinding of ferrous and non-ferrous metals including titanium & other super alloys. It can also be used for drilling and general machining applications, as well as for hard metal and tool grinding. CareCut ES 2 does not contain active sulphur and is hence compatible with yellow metals",
            "link":"https://thelubricantoracle.castrol.com/product/carecut-es-2/industrial/en-JP"
        },
    ];

    let OtherAlloysSuperfinishing= [
        {
            "title":"Honilo 930",
            "text":"A chlorine and heavy metal free neat cutting oil specially formulated with a special combination of ester, extreme pressure (EP) and anti-wear additives to help to optimise machining performance and enhance tool life. It is designed for severe broaching and gear cutting of high alloy steel and stainless steel. Variocut B 46 TC contains active sulphur and is not compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/variocut-b-46-tc/industrial/en-JP"
        },
        {
            "title":"Honilo 981",
            "text":"A chlorine and heavy metal free low viscosity neat cutting oil for honing and superfinishing of cast iron, steel and aluminium alloys, where critical dimensional accuracy are required.",
            "link":"https://thelubricantoracle.castrol.com/product/honilo-981/industrial/en-JP"
        },
        {
            "title":"Honilo 988",
            "text":"A chlorine and heavy metal free low viscosity neat cutting oil specially designed for honing and superfinishing of ferrous and non-ferrous materials. It is specially designed to inhibit staining where sulphurised honing sticks are used and to improve in-process corrosion protection for the bearing industry. Honilo 988 does not contain active sulphur and is compatible with yellow metals.",
            "link":"https://thelubricantoracle.castrol.com/product/honilo-988/industrial/en-JP"
        }
    ];

    

    let content;
    if(firstTitle==="Cast Iron"){
        if(secondTitle==="Broaching"){
            {/* CAST IRON - BROACHING */}
            content =
            <div>
                {
                    CastIronBroaching.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Deep Drilling"){
             {/*CAST IRON - DEEP DRILLING*/}
             content =
            <div>
                {
                    CastIronDeepDrilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Grinding"){
            {/*CAST IRON - GRINDING*/}
            content =
            <div>
                {
                    CastIronGrinding.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Milling"){
            {/*CAST IRON - MILLING*/}
            content =
            <div>
                {
                    CastIronMilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Drilling"){
            {/*CAST IRON - DRILLING*/}
            content =
            <div>
                {
                    CastIronDrilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Superfinishing"){
            {/*CAST IRON - SUPERFINISHING*/}
            content =
            <div>
                {
                    CastIronSuperfinishing.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
    } else if (firstTitle==="Aluminium") {
        if(secondTitle==="Broaching"){
            {/*ALUMINIUM - BROACHING*/}
            content =
            <div>
                {
                    AluminumBroaching.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Deep Drilling"){
            {/*ALUMINIUM - DEEP DRILLING*/}
            content =
            <div>
                {
                    AluminumDeepDrilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Grinding"){
            {/*ALUMINIUM - GRINDING*/}
            content =
            <div>
                {
                    AluminumGrinding.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Milling"){
            {/*ALUMINIUM - MILLING*/}
            content =
            <div>
                {
                    AluminumMilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Drilling"){
            {/*ALUMINIUM - DRILLING*/}
            content =
            <div>
                {
                    AluminumDrilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Superfinishing"){
            {/*ALUMINIUM - SUPERFINISHING*/}
            content =
            <div>
                {
                    AluminumSuperfinishing.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
    } else if (firstTitle==="High Alloy Steel  / Stainless Steel") {
        if(secondTitle==="Broaching"){
            {/*HIGH ALLOY - BROACHING*/}
            content =
            <div>
                {
                    HighAlloySteelBroaching.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Deep Drilling"){
            {/*HIGH ALLOY - DEEP DRILLING*/}
            content =
            <div>
                {
                    HighAlloySteelDeepDrilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Grinding"){
            {/*HIGH ALLOY - GRINDING*/}
            content =
            <div>
                {
                    HighAlloySteelGrinding.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Milling"){
            {/*HIGH ALLOY - MILLING*/}
            content =
            <div>
                {
                    HighAlloySteelMilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Drilling"){
            {/*HIGH ALLOY - DRILLING*/}
            content =
            <div>
                {
                    HighAlloySteelDrilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Superfinishing"){
            {/*HIGH ALLOY - SUPERFINISHING*/}
            content =
            <div>
                {
                    HighAlloySteelSuperfinishing.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
    } else if (firstTitle==="Yellow Metal") {
        if(secondTitle==="Broaching"){
            {/*YELLOW METAL - BROACHING*/}
            content =
            <div>
                {
                    YellowMetalBroaching.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Deep Drilling"){
            {/*YELLOW METAL - DEEP DRILLING*/}
            content =
            <div>
                {
                    YellowMetalDeepDrilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Grinding"){
            {/*YELLOW METAL - GRINDING*/}
            content =
            <div>
                {
                    YellowMetalGrinding.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Milling"){
            {/*YELLOW METAL - MILLING*/}
            content =
            <div>
                {
                    YellowMetalMilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Drilling"){
            {/*YELLOW METAL - DRILLING*/}
            content =
            <div>
                {
                    YellowMetalDrilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Superfinishing"){
            {/*YELLOW METAL - SUPERFINISHING*/}
            content =
            <div>
                {
                    YellowMetalSuperfinishing.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
    } else if (firstTitle==="Low/Med Alloy Steel") {
        if(secondTitle==="Broaching"){
            {/*LOW ALLOY - BROACHING*/}
            content =
            <div>
                {
                    LowAlloySteelBroaching.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Deep Drilling"){
            {/*LOW ALLOY - DEEP DRILLING*/}
            content =
            <div>
                {
                    LowAlloySteelDeepDrilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Grinding"){
            {/*LOW ALLOY - GRINDING*/}
            content =
            <div>
                {
                    LowAlloySteelGrinding.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Milling"){
            {/*LOW ALLOY - MILLING*/}
            content =
            <div>
                {
                    LowAlloySteelMilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Drilling"){
            {/*LOW ALLOY - DRILLING*/}
            content =
            <div>
                {
                    LowAlloySteelDrilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Superfinishing"){
            {/*LOW ALLOY - SUPERFINISHING*/}
            content =
            <div>
                {
                    LowAlloySteelSuperfinishing.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
    } else if (firstTitle==="Other Alloys") {
        if(secondTitle==="Broaching"){
            {/*OTHER ALLOYS - BROACHING*/}
            content =
            <div>
                {
                    OtherAlloysBroaching.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Deep Drilling"){
            {/*OTHER ALLOYS - DEEP DRILLING*/}
            content =
            <div>
                {
                    OtherAlloyDeepDrilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Grinding"){
            {/*OTHER ALLOYS - GRINDING*/}
            content =
            <div>
                {
                    OtherAlloysGrinding.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Milling"){
            {/*OTHER ALLOYS - MILLING*/}
            content =
            <div>
                {
                    OtherAlloysMilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Drilling"){
            {/*OTHER ALLOYS - DRILLING*/}
            content =
            <div>
                {
                    OtherAlloysDrilling.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
        else if(secondTitle==="Superfinishing"){
            {/*OTHER ALLOYS - SUPERFINISHING*/}
            content =
            <div>
                {
                    OtherAlloysSuperfinishing.map(
                        (data) =>   <MachineSubcard
                                        title={data.title}
                                        text={data.text}
                                        link={data.link}
                                    />
                    )
                } 
            </div>
        }
    }
       


    return (
        <div>
            {content}
        </div>
    )
}
export default Index;